import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { FeedbackReceived } from 'app/teacher/gameshow/feedback/models/feedback-received.model';

import { GameShowStatInfo } from './models/gameshow-stat-info';
import { TeacherGameShowInfo } from './models/teacher-gameshow-info.model';
import { TeacherGameShowQuestionChoice } from './models/teacher-gameshow-question-choice.model';

export const GAMESHOW_REPOSITORY = new InjectionToken<GameShowRepository>('GAMESHOW_REPOSITORY');

export interface GameShowRepository {

  disconnectChannel(classId: string): void;

  getDate(): Date;

  getFeedback(classId: string): Observable<FeedbackReceived>;

  getGameShow(classId: string): Observable<any>;

  getPublicGameShow(classId: string): Observable<GameShowStatInfo | null>;

  getTeacherGameShowLive(classId: string, gameShowRunId: string, attemptNumber: number): Observable<TeacherGameShowInfo | null>;

  getQuestionChoices(classId: string): Observable<TeacherGameShowQuestionChoice[] | null>;

  getGameShowRunId(classId: string): Observable<string | null>;

  getRejectedStudents(classId: string): Observable<Record<string, any> | null>;
}
